import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class QuadradicDiscriminantAnalysisGraph extends AbstractScatterVisualization {
}
